import { Component } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { StorageService } from '@app/services/storage/storage.service';
import { SpinnerService } from '@app/services/spinner/spinner.service';
import { ServiceConfigService } from '@app/services/service-config.service';

@Component({
    template: ``,
    standalone: false
})
export class NotFoundComponent {
  constructor(
    private router: Router, //
    private spinner: SpinnerService,
    private storage: StorageService,
    private serverConfig: ServiceConfigService,
    private route: ActivatedRoute,
  ) {
    const url = this.router.url;
    let whitelistedParam;
     const campaignUrl_params = this.serverConfig.getServerConfig().campaignUrl_params;
    this.route.queryParams.subscribe((res: any) => {
      const allParams : string[] = [];
      allParams.push(...campaignUrl_params.split(','))
       whitelistedParam = allParams.find(key => !!res[key])
    })
    const campaighUrl_Facebook = this.serverConfig.getServerConfig().campaighUrl_Facebook;
    let allFaceBookUrls : string[] = [];
    allFaceBookUrls.push(...campaighUrl_Facebook.split(','));
    if( whitelistedParam || (allFaceBookUrls.includes(url))){
     this.router.navigateByUrl('/', {skipLocationChange: true})
    } else {
      this.spinner.increment();
      this.router
      .navigate(['/application/', this.storage.getAppNumber()])
      .then(() => this.spinner.decrement());
    }
    
  }
}
